// extracted by mini-css-extract-plugin
export var divider = "landing-module--divider--I1Efv";
export var name = "landing-module--name--Pt2Uq";
export var landing_image = "landing-module--landing_image--od2vb";
export var mainDiv = "landing-module--mainDiv--x0EnV";
export var sideDiv = "landing-module--sideDiv--ICiQ9";
export var locationText = "landing-module--locationText--ZSgBI";
export var imgDiv = "landing-module--imgDiv--9YZx3";
export var flip = "landing-module--flip--z6H7I";
export var show = "landing-module--show--1WARY";